import { ProductLogoMediumOrganization } from "@/components/Logo/Product";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/organization/_list")({
  component: OrganizationListLayout,
});

function OrganizationListLayout() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.organization",
  });
  useDocumentTitle(t("organization"));

  const tabs = [
    {
      to: "/organization",
      children: t("tabs.overview"),
      activeOptions: { exact: true },
      disabled: true,
    },
    {
      to: "/organization/chart",
      children: t("tabs.chart"),
      activeOptions: { exact: true },
    },
    {
      to: "/organization/history",
      children: t("tabs.history"),
      activeOptions: { exact: true },
      disabled: true,
    },
    {
      to: "/organization/cost",
      children: t("tabs.cost"),
      activeOptions: { exact: true },
      disabled: true,
    },
    {
      to: "/organization/alert",
      children: t("tabs.alert"),
      activeOptions: { exact: true },
      disabled: true,
    },
    {
      to: "/organization/rule-policy",
      children: t("tabs.rulePolicy"),
      activeOptions: { exact: true },
      disabled: true,
    },
    {
      to: "/organization/settings",
      children: t("tabs.settings"),
      activeOptions: { exact: true },
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={ProductLogoMediumOrganization}
        name={t("organization")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
